<template>
    <div id="treeBox" >
        <div class="directory">目录</div>
        <div class="treeTitle">
            <img src="/static/images/treeIcon.png" alt="">{{title}}
        </div>
        <Tree :data="datas" @on-select-change="clickSection"></Tree>
    </div>
</template>
<script>
import bus from '../../assets/eventBus/enentBus.js'
import api from '../../utils/api.js'
export default {
    name:'directoryTree',
    data(){
        return {
            urlHttp:'/testIp',
            title:null,
            courseId:null,                            //课 id
            datas: [],
            materialId:362,                            //教材id
            knowledgeId:null
        }
    },
    mounted(){
        const that = this;
        bus.$off('materialId');
        bus.$on('materialId',function(msg){
            if(msg != 'null'){
                that.materialId = msg.id;
                that.knowledgeId = msg.knowladgeId;
                that.getMaterialData()
            }else{
                that.datas = [];
                that.title = '暂无教材'
            }
            bus.$emit('tbMaterialId',msg)
        })
    },
    methods:{
        getMaterialData(){
            const that = this;
            const url =  '/axt-future/liveTeaching/selectAllInfoByIds';
            const params = {
                'liveTeachingIds':this.materialId
            };
            api.getListAPI(url,params).then(res => {
                const data1 = [];
                if(res.data.message == 'success'){
                    const obj = res.data.data[0];
                    that.title = obj.name;                //目录树 title
                    that.courseId = obj.knowledgeId;      // 赋值 课id
                    const course = obj.knowledges;          // 章
                    for(let i = 0; i < course.length; i++){
                        const courseObj = {};
                        // if(i == 0){
                        //     courseObj.expand = true;
                        // }
                        courseObj.title = course[i].klName;
                        courseObj.klId = course[i].klId;
                        courseObj.level = 2;
                        courseObj.children = [];
                        data1.push(courseObj);
                        const chapter = course[i].childKnowledges;      //讲
                        for(let k = 0; k < chapter.length; k++){
                            const chapterObj = {}
                            // if(k == 0){
                            //     chapterObj.expand = true;
                            // }
                            chapterObj.title = chapter[k].klName;
                            chapterObj.klId = chapter[k].klId;
                            chapterObj.level = 3;
                            chapterObj.children = [];
                            data1[i].children.push(chapterObj);
                            const section = chapter[k].childKnowledges;
                            for(let j = 0; j < section.length; j++){
                                const sectionObj = {};
                                // if(i == 0 && k == 0 && j == 0){
                                //     // sectionObj.selected = 'selected'
                                // }
                                sectionObj.title = section[j].klName;
                                sectionObj.klId = section[j].klId;
                                sectionObj.level = 4;
                                sectionObj.children = [];
                                data1[i].children[k].children.push(sectionObj)
                            }
                        }

                    }
                    that.datas = data1;
                    const list = {
                        knowladgeId:that.knowledgeId,
                        level:1
                    }
                    bus.$emit('knowledgeId',list)
                }
            })
        },
        clickSection(name){
            const list = {
                knowladgeId:name[0].klId,
                level:name[0].level
            }
            bus.$emit('knowledgeId',list)
        }
    }
}
</script>
<style lang="">
    #treeBox{
        width:17%;
        border: 1px solid #DADADA;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    #treeBox .ivu-tree ul li{
        text-align: left;
        padding-left: 8%;
    }
    #treeBox .ivu-tree li ul{
        padding: 0;
    }
    #treeBox .ivu-tree-title-selected,#treeBox .ivu-tree-title:hover{
        background: none;
        color: #3583FF;
    }
    .directory{
        width:100%;
        height: 50px;
        background: #F7F8FA;
        border-top: solid 2px #3583FF;
        line-height: 50px;
        font-weight: 500;
        color: #34495E;
        font-size:16px;
        text-align: left;
        padding-left: 5%;
    }
    .treeTitle{
        width:100%;
        height: 56px;
        line-height: 56px;
        color: #34495E;
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        padding-left: 5%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .treeTitle img{
        width:16px;
        height:16px;
        margin-right: 5px;
    }
    #treeBox ul{
        font-size: 14px;
    }
    #treeBox ul {
        font-weight: 600;
        color: #34495E;
    }
    #treeBox ul ul {
        font-weight: 500;
        /* color: #34495E; */
    }
    #treeBox ul ul ul span{
         color:#9A9A9A;
         font-weight: 500;
    }
    
    #treeBox .ivu-tree{
        min-height: 960px;
        overflow-x:scroll;     
        overflow-y:scroll;     
    }
    #treeBox .ivu-tree ul li{
        margin: 10px 0;
    }
     /*滚动条样式*/
    .ivu-tree::-webkit-scrollbar {
        width: 4px;    
        height: 10px;
    }
    .ivu-tree::-webkit-scrollbar-thumb {
        border-radius: 10px;
        /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
        background: rgba(0,0,0,0.2);
    }
    .ivu-tree::-webkit-scrollbar-track {
        /* -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.2); */
        border-radius: 0;
        background: rgba(0,0,0,0);

    }
    
</style>



// WEBPACK FOOTER //
// src/components/DirectoryTree/DirectoryTree.vue